import { render } from "./LeftSideReportsItem.vue?vue&type=template&id=55551643&scoped=true"
import script from "./LeftSideReportsItem.vue?vue&type=script&lang=js"
export * from "./LeftSideReportsItem.vue?vue&type=script&lang=js"

import "./LeftSideReportsItem.vue?vue&type=style&index=0&id=55551643&scoped=true&lang=css"

import exportComponent from "/home/azael/Documents/GitHub/tempo-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55551643"]])

export default __exports__